import type { ReactNode } from "react";

/**
 * Beschreibungskarte (Musterkatalog M-187, Design-Guide `beschreibungs-karte.md`): eine Karte mit Titel, einer Aktion rechts im Kopf
 * (z. B. „Bearbeiten“) und Zeilen aus Beschriftung und Wert mit gestrichelten Trennlinien (Katalog `dashed-description-list…`).
 * Am Fuß steht höchstens EINE Zeile für nicht gepflegte Angaben („1 Angabe fehlt · ergänzen“), nie eine Reihe leerer Zeilen.
 * Rein darstellend: ob „Bearbeiten“ und „ergänzen“ angeboten werden, entscheidet der Aufrufer mit derselben Prüfung wie die Action (r110).
 */
export function BeschreibungsKarte({
  id,
  titel,
  aktion,
  fuss,
  children,
}: {
  id: string;
  titel: string;
  /** Knopf rechts im Kopf; im Bearbeiten-Modus entfällt er (Speichern und Abbrechen stehen am Fuß). */
  aktion?: ReactNode;
  /** Fußzeile (Zählzeile „fehlt · ergänzen“ oder Speichern/Abbrechen). */
  fuss?: ReactNode;
  children: ReactNode;
}) {
  return (
    <>
      {/* Preline: data-display/data-display-sub-operational-activity-views/data-display-cat-description-lists/dashed-description-list-with-copy-actions */}
      <section aria-labelledby={`${id}-titel`} className="bg-card border border-card-line shadow-2xs rounded-xl">
        <div className="px-5 pt-4 flex flex-wrap items-center justify-between gap-2">
          <h2 id={`${id}-titel`} className="text-sm font-semibold text-foreground">
            {titel}
          </h2>
          {aktion}
        </div>
        <dl className="px-5 pb-1 pt-2 divide-y divide-dashed divide-line-2">{children}</dl>
        {fuss && <div className="px-5 pb-4 pt-2 text-sm text-muted-foreground-1">{fuss}</div>}
      </section>
    </>
  );
}

/** Eine Zeile der Beschreibungskarte: Beschriftung links, Wert rechts (mobil untereinander). */
export function BeschreibungsZeile({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="py-3 grid grid-cols-1 sm:grid-cols-3 gap-x-3 gap-y-1">
      <dt className="text-sm text-muted-foreground-1">{label}</dt>
      <dd className="sm:col-span-2 min-w-0 text-sm text-foreground break-words">{children}</dd>
    </div>
  );
}
